module.exports = __webpack_public_path__ + "static/media/hiking.ffb869e3.jpg";